import Router from "next/router";
import { Button } from "@moneyforward/mfx_biz_react_components";

export const RegisterUserButton = () => {
  const onClick = () => {
    Router.push("/register-user");
  };

  return (
    <Button variant="secondary" onClick={onClick}>
      新規作成
    </Button>
  );
};
